import {
  Truck,
  Star,
  Heart,
  Users,
  Shield,
  Clock,
  Check,
  Award,
  Package,
  Bell,
  Mail,
  Phone,
  MapPin,
  Calendar,
  Zap,
  Settings,
  Circle,
} from "lucide-react";

// Fixed, safe allow-list -- widget icon props are just a string key from
// page_widgets.props_json (admin/AI-authored data, not code), so the set of
// renderable icons has to be a closed lookup rather than a dynamic import by
// name. Unrecognized keys fall back to a plain circle instead of crashing
// the page.
export const WIDGET_ICONS = {
  truck: Truck,
  star: Star,
  heart: Heart,
  users: Users,
  shield: Shield,
  clock: Clock,
  check: Check,
  award: Award,
  package: Package,
  bell: Bell,
  mail: Mail,
  phone: Phone,
  "map-pin": MapPin,
  calendar: Calendar,
  zap: Zap,
  settings: Settings,
};

export const resolveWidgetIcon = (name) => WIDGET_ICONS[name] || Circle;
